// Styles
import styles from './ActionsTitle.module.css';

export const ActionsTitle = ({titleName}) => {
  return(
    <h2 className={styles.title}>ACTIONS LIST</h2>
  );
};